import { API_BASE_URL } from "../../../config"
import request from "../../../utilities/request"

const cancelAssigmnet = (assetUuid, distributionId) => request.delete(`${API_BASE_URL}/blockchain/assets/${assetUuid}/distributions/${distributionId}`)

export default cancelAssigmnet;